import Immutable from 'immutable';
import { GET_COUNTRIES } from '../constants';

const INITIAL_STATE = Immutable.fromJS({countries: [], countriesCount: 0});

export default function (state = INITIAL_STATE, action)
{
	let nextState = state.toJS();

	switch (action.type) {
		case GET_COUNTRIES:
            nextState.countries = action.payload.rows
            nextState.countriesCount = action.payload.count
        break;
        default:

        break;
	}

	return state.merge(nextState);
}
